export const mergeAriaIds = (
  ...ids: Array<string | undefined | null | false>
): string | undefined => {
  const result = ids.filter(Boolean).join(' ')
  return result || undefined
}
